// extracted by mini-css-extract-plugin
export default {"tableModule":"tableModule--DJ4yq","specialTable":"specialTable--Bbm8Z","markerAnimationScale":"markerAnimationScale--ku4pO"};